import React, { useState } from 'react';
import Navigation from './components/Navigation';
import DashboardView from './components/views/DashboardView';
import LibraryView from './components/views/LibraryView';
import ScheduleView from './components/views/ScheduleView';
import LayoutView from './components/views/LayoutView';
import SuppliesView from './components/views/SuppliesView';
import DemoView from './components/views/DemoView';
import SafeIcon from './common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { GardenLogo } from './components/BrandAssets';

const { FiBell, FiZap } = FiIcons;

export default function App() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const renderContent = () => {
    switch(activeTab) {
      case 'dashboard': return <DashboardView />;
      case 'library': return <LibraryView />;
      case 'schedule': return <ScheduleView />;
      case 'layout': return <LayoutView />;
      case 'supplies': return <SuppliesView />;
      case 'demo': return <DemoView />;
      default: return <DashboardView />;
    }
  };

  return (
    <div className="flex h-screen bg-garden-darkest overflow-hidden font-sans text-clay selection:bg-lime selection:text-garden-darkest">
      <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <div className="flex-1 flex flex-col relative h-full overflow-hidden">
        {/* Mobile Header */}
        <header className="md:hidden h-16 bg-garden-dark border-b border-garden-base flex items-center justify-between px-6 shrink-0 z-40">
          <div className="flex items-center gap-3">
            <GardenLogo className="w-8 h-8" />
            <span className="text-lime font-black tracking-tighter text-sm uppercase">GardenGlide</span>
          </div>
          <div className="flex items-center gap-4">
             <div className="text-[9px] font-mono bg-garden-base px-2 py-0.5 rounded text-lime uppercase tracking-widest">LV_04</div>
             <div className="w-9 h-9 rounded-xl bg-garden-base flex items-center justify-center border border-garden-base/50">
               <SafeIcon icon={FiBell} className="text-clay text-lg" />
             </div>
          </div>
        </header>

        {/* Global UI Background effects */}
        <div className="absolute top-0 left-0 w-full h-full bg-grid-pattern opacity-5 pointer-events-none -z-20"></div>
        <div className="absolute top-[10%] left-[5%] w-[600px] h-[600px] bg-lime/10 rounded-full blur-[180px] pointer-events-none -z-10 opacity-40"></div>
        <div className="absolute bottom-[5%] right-[5%] w-[400px] h-[400px] bg-blue-500/5 rounded-full blur-[150px] pointer-events-none -z-10 opacity-30"></div>

        {/* Content Area */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-12 relative scroll-smooth scrollbar-hide">
          <div className="h-full max-w-[1600px] mx-auto">
            {renderContent()}
          </div>
        </main>

        <footer className="w-full py-3 px-12 flex justify-between items-center bg-garden-darkest/95 border-t border-garden-base/20 backdrop-blur-md shrink-0 md:flex hidden">
          <div className="flex items-center gap-4 grayscale opacity-40 hover:grayscale-0 hover:opacity-100 transition-all cursor-crosshair">
            <GardenLogo className="w-6 h-6" variant="light" />
            <span className="text-[10px] font-mono text-clay-dark uppercase tracking-[0.3em]">GLIDE_SYS_V4.3</span>
          </div>
          <div className="text-[10px] text-clay-dark font-mono uppercase tracking-[0.2em] flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-lime rounded-full"></span>
            Made by LingLink AI and DigLab AI
          </div>
        </footer>
      </div>
    </div>
  );
}